import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-attribute-list',
    templateUrl: './attribute-list.component.html',
    styleUrls: ['./attribute-list.component.scss'],
    standalone: false
})
export class AttributeListComponent implements OnInit {

    @Input() attributes: string[];

    validAttributes: string[];
    hasAttributes: boolean = false;

    constructor() { }

    attributesFormatted :string;
    ngOnInit() {
        this.validAttributes = [];
        for (let a in this.attributes) {
            let val = this.attributes[a];
            if (val) {
                val = val.trim();
            }
            if (val!=''&&val!='Other') {
                this.validAttributes.push(val);
            }
        }

        this.hasAttributes = (this.validAttributes.length > 0);

        this.attributesFormatted = this.validAttributes.join(" • ");

        if (this.attributesFormatted.endsWith(" • ")) {
            this.attributesFormatted = this.attributesFormatted.slice(0, -3);
        }
    }
}
